import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class PodsIndicatorCtrl implements IController {
  pods: any;
  identifications: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.identifications) {
      this.pods = _.chain(this.identifications)
        .pickBy((value, key) => {
          return value === true;
        })
        .keys()
        .value();
    }

    if (!this.pods) {
      this.pods = [];
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('podsIndicator', {
    bindings: {
      pods: '<?',
      identifications: '<?'
    },
    template: require('./pods-indicator.html').default,
    controller: PodsIndicatorCtrl
  });
